import { computed, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { DashboardMaintenance } from '@airwallet/shared-models/dashboard-maintenance';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceService {
    checkingForMaintenance: WritableSignal<boolean> = signal(true);
    maintenance: WritableSignal<DashboardMaintenance> = signal(null);
    currentTime: WritableSignal<number> = signal(Math.floor(Date.now() / 1000)); // Current time in seconds

    constructor() {
        // Update currentTime every second
        setInterval(() => {
            this.currentTime.set(Math.floor(Date.now() / 1000));
        }, 1000);
    }

    isUnderMaintenance: Signal<boolean> = computed(() => {
        const maintenanceEnd: number = this.maintenance()?.end ?? 0;
        const maintenanceStart: number = this.maintenance()?.start ?? 1;
        return maintenanceEnd > this.currentTime() && maintenanceStart < this.currentTime();
    });

    maintenanceWillBegin: Signal<boolean> = computed(() => {
        const maintenanceStart: number = this.maintenance()?.start ?? 0;
        const currentTime: number = this.currentTime();
        const lessThan4HoursTo: boolean = maintenanceStart - currentTime <= 14400; // 4 hours in seconds
        return maintenanceStart > currentTime && lessThan4HoursTo;
    });

    dashboardBackAt: Signal<number> = computed(() => {
        const maintenanceEnd: number = this.maintenance()?.end ?? 0;
        const isUnderMaintenance = this.isUnderMaintenance();

        if (isUnderMaintenance) {
            return maintenanceEnd;
        }
    });

    maintenanceCountdown: Signal<string> = computed(() => {
        const currentTime = this.currentTime(); // Use reactive currentTime
        const maintenanceStart: number = this.maintenance()?.start ?? 0;

        if (maintenanceStart > currentTime) {
            const remainingTime = maintenanceStart - currentTime;
            const hours = Math.floor(remainingTime / 3600);
            const minutes = Math.floor((remainingTime % 3600) / 60);

            if (remainingTime < 300) {
                // Below 5 minutes
                const seconds = remainingTime % 60;
                return `${hours}h ${minutes}m ${seconds}s`;
            }

            return `${hours}h ${minutes}m`;
        }

        return 'Maintenance has started';
    });
}
